module.exports = __webpack_public_path__ + "img/btn-1.f18e6a49.png";